import React from 'react'
import PropTypes from 'prop-types'

const renderOption = x => (
  <option key={x.value} value={x.value}>
    {x.label}
  </option>
)

// `options` is either a flat array of {value, label}, or a grouped array
// of {label, options: [{value, label}]} rendered as <optgroup> sections.
const InlineSelect = ({ value, setValue, label, options }) => {
  const onChange = event => {
    setValue(event.target.value)
  }
  const isGrouped = options.length > 0 && Array.isArray(options[0].options)

  return (
    <select
      className="pa1 mh2 tac ba bw2 b--dashed b--light-gray pointer hover-bg-light-gray"
      aria-label={label}
      value={value}
      placeholder={label}
      onChange={onChange}
      style={{
        WebkitAppearance: 'none',
        MozAppearance: 'none',
      }}
    >
      {isGrouped
        ? options.map(group => (
            <optgroup label={group.label} key={group.label}>
              {group.options.map(renderOption)}
            </optgroup>
          ))
        : options.map(renderOption)}
    </select>
  )
}

InlineSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setValue: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
      }),
      PropTypes.shape({
        label: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            label: PropTypes.string,
          })
        ),
      }),
    ])
  ).isRequired,
}

export default InlineSelect
